// extracted by mini-css-extract-plugin
module.exports = {"cls1":"footer-Container-module--cls1--3YkGy","noMarginTop":"footer-Container-module--noMarginTop--3bP9f"};